import codes from "../data/fcrmCountryCodes.json";

const ALIASES = {
  "cape verde": "CV",
  myanmar: "MM",
  "vatican city": "VA",
  congo: "CG",
};

export const fcrmCountryCode = (value) => {
  const key = String(value ?? "").trim().toLowerCase();
  if (!key) return "";
  return ALIASES[key] || codes[key] || "";
};

export const fcrmCountryCodes = (names = []) => {
  const seen = new Set();
  const result = [];
  for (const name of names) {
    const code = fcrmCountryCode(name);
    if (!code || seen.has(code)) continue;
    seen.add(code);
    result.push(code);
  }
  return result;
};
